// import stores from '@/public/assets/mockups/stores.json';
// import { isValidJSON } from '@/utilities/checker';

import { AK } from "@/constants";

// const getFBConversionID = async () => {
//   try {
//     var fbpixelid = '';
//     const marketing_config_fb_conversionid = 1;
//     if (isValidJSON(stores[0]?.marketing_config)) {
//       var fb_conversion = JSON.parse(stores[0]?.marketing_config);
//       const datasetid = fb_conversion?.find(
//         (_fb) => _fb?.id === marketing_config_fb_conversionid,
//       )?.datasetid;
//       if (datasetid) {
//         fbpixelid = datasetid;
//       }
//     }
//     return fbpixelid;
//   } catch (error) {
//     console.error('Failed to fetch the JSON file:', error);
//     return null;
//   }
// };

export const FB_PIXEL_ID = AK.FB_PIXEL_ID; //await getFBConversionID(); // // Replace with your actual Pixel ID

export const pageview = () => {
  window.fbq("track", "PageView");
  //AddPaymentInfo
  //AddToCart
  //AddToWishlist
  //CompleteRegistration
  //Contact
  //InitiateCheckout
  //Purchase
  //Search
  //ViewContent
};

export const fbevent = (name, options = {}, eventID = "") => {
  if (typeof window !== "undefined" && window.fbq) {
    if (eventID) {
      window.fbq("track", name, options, { eventID });
    } else {
      window.fbq("track", name, options);
    }
  }
};
